/*
 * @author Felix Baltruschat <fb@braune-digital.com>
 * @copyright 2018 Braune Digital GmbH
 */

import { ErrorServiceInterface } from './error.interface';
import { Subject } from 'rxjs';

export abstract class ErrorServiceAbstract implements ErrorServiceInterface {
  abstract propertyError: Subject<{ property_path: string; message: string }>;
  abstract error: Subject<string>;
}
